/**
 * Compute post-edit markdown for preview (mirrors neoAiApplyEdit string logic).
 */

export function computeProposedMarkdown({
  documentMarkdownSent = "",
  edit,
  responseMd = "",
  currentMarkdown = "",
}) {
  const base = typeof documentMarkdownSent === "string" ? documentMarkdownSent : "";
  const current =
    typeof currentMarkdown === "string" && currentMarkdown.trim()
      ? currentMarkdown
      : base;

  if (!edit || typeof edit !== "object") {
    const incoming = typeof responseMd === "string" ? responseMd.trim() : "";
    if (!incoming) {
      return { before: current, after: current, summary: "empty" };
    }
    return {
      before: current,
      after: current,
      incomingOnly: incoming,
      summary: "plain_insert",
    };
  }

  const mode = edit.edit_mode;
  const markdown = typeof edit.markdown === "string" ? edit.markdown : "";

  if (!markdown.trim()) {
    return { before: current, after: current, summary: "empty" };
  }

  if (mode === "full_document") {
    return {
      before: current,
      after: markdown,
      summary: "full_document",
    };
  }

  if (mode === "append") {
    const trimmedBase = (base || current).replace(/\s*$/, "");
    return {
      before: current,
      after: `${trimmedBase}\n\n${markdown.trim()}`,
      summary: "append",
    };
  }

  if (mode === "replace_between_anchors") {
    const doc = base || current;
    const a0 = edit.anchor_start;
    const a1 = edit.anchor_end;
    if (typeof a0 !== "string" || typeof a1 !== "string" || !a0 || !a1) {
      return { before: current, after: current, summary: "invalid_anchors" };
    }
    const i = doc.indexOf(a0);
    if (i < 0) {
      return { before: current, after: current, summary: "anchor_start_not_found" };
    }
    const j = doc.indexOf(a1, i + a0.length);
    if (j < 0 || j <= i) {
      return { before: current, after: current, summary: "anchor_end_not_found" };
    }
    const after = doc.slice(0, i) + markdown + doc.slice(j);
    return {
      before: current,
      after,
      summary: "replace_between_anchors",
      changedSegmentBefore: doc.slice(i, j),
      changedSegmentAfter: markdown,
    };
  }

  if (mode === "insert_at_cursor") {
    return {
      before: current,
      after: current,
      incomingOnly: markdown,
      summary: "insert_at_cursor",
    };
  }

  return { before: current, after: current, summary: "unknown_edit_mode" };
}
